import _ from 'lodash'
import moment from 'moment'
import avg from 'average-array-objects'

export default {
    groupByMonth(arr) {
        return _.groupBy(_.clone(arr), (result) => moment(result['date']).startOf('month').format())
    },
    groupByWeek(arr) {
        return _.groupBy(_.clone(arr), (result) => moment(result['date']).startOf('week').format())
    },
    getIndicatorsList(arr) {
        let res = _.groupBy(_.clone(arr), (result) => result.indicator)
        let result = []
        _.forOwn(res, function (value, key) {
            result.push({
                value: key,
                label: key
            })
        })
        result = _.sortBy(result, [function (o) {
            return o.label;
        }])
        return result
    },
    averageByIndicator(arr) {
        arr = _.cloneDeep(arr)
        let finalArray = []
        let finalArrayRaw = []
        let res = _.map(_.clone(arr), function (val, key) {
            let dateResult = key
            let arrTemp = []
            let tt = _.groupBy(val, 'indicator')
            _.forOwn(tt, function (value, kk) {
                let keyIndicator = kk
                value.forEach(function (v) {

                    delete v.date
                    delete v.indicator
                    v['value'] = parseFloat(v['value'])
                });
                let avgValue = avg(value, ['_id']);
                let objPowered = {
                    date: dateResult,
                    indicator: keyIndicator,
                    value: Math.floor(avgValue.value * 2) / 2
                }
                arrTemp.push(objPowered)
                finalArrayRaw.push(objPowered)
            })
            let ob = {}
            ob[dateResult] = arrTemp
            finalArray.push(ob)
            return {finalArray, finalArrayRaw}
        })
        return !_.isUndefined(res[0]) ? {"by_split_date": res[0].finalArray, "list": res[0].finalArrayRaw} : false
    },
    getByColumnData(arr, freqType = 'month') {
        arr = _.clone(arr)
        let finalArray = []
        let columns = []
        let o = _.groupBy(arr, (result) => result['indicator'])
        _.each(o, (value, key) => {
            let obj = {}
            obj['indicator'] = key
            value.forEach(function (elem) {
                let dateFormated = freqType === 'month' ?
                    moment(elem.date).format('YYYY-MM').toString() :
                    moment(elem.date).format('YYYY-MM-DD').toString()
                let dateMonthHuman =
                    freqType === 'month' ?
                        moment(elem.date).format('MMM').toString() + ' ' +
                        moment(elem.date).format('YYYY').toString() :
                        "Week " + moment(elem.date).format('w').toString() + ' ' +
                        moment(elem.date).format('YYYY').toString()
                let dateItem = {
                    dateFormated, dateMonthHuman
                }
                obj[dateFormated] = elem.value
                if (!_.find(columns, dateItem)) {
                    columns.push(dateItem)
                }
            })
            finalArray.push(obj)
        })
        columns = _.sortBy(columns, [function (o) {
            return o.dateFormated;
        }])
        let columnsDtFormated = []
        columns.forEach(function (el) {
            let o = {
                data: el.dateFormated,
                title: el.dateMonthHuman,
                defaultContent: "NA"
            }
            columnsDtFormated.push(o)
        })
        columnsDtFormated.unshift({
            data: 'indicator',
            title: 'indicator',
            defaultContent: "nul"
        })
        return {columnsDtFormated, finalArray}
    },
    getColumnMonthNameDt(arr) {
        arr = _.clone(arr)
        let aFinal = []
        let columnDef = []
        let i;
        for (i = 0; i < arr.length - 1; i++) {
            aFinal.push(i + 1)
        }
        let obj = {}
        obj["targets"] = aFinal
        columnDef.push(obj)
        return columnDef
    },
    setNewDataToTable(dt, data) {
        dt.clear().draw()
        dt.rows.add(data).draw()
    },
    createTableDomElement(jqElemContainer) {
        let out = $('<table />', {
            "id": 'tontonistonton',
            "class": 'table table-hover'
        })
        jqElemContainer.append(out)
        return out
    },
    getValueDateByIndicator(arr, indicator) {
        let arr2 = arr.filter(o => o.indicator == indicator)
        arr2 = _.sortBy(arr2, 'date')
        let finalArr = []

        let xAxis = []
        let yAxis = []
        arr2.forEach(function (elem) {
            finalArr.push({
                x: new Date(elem.date),
                y: elem.value
            })
        })
        return finalArr
    },
    getBornedDateOfArray(arr) {
        let maxDate = new Date(Math.max.apply(null, arr.map(function (e) {
            return new Date(e.date)
        })));
        let minDate = new Date(Math.min.apply(null, arr.map(function (e) {
            return new Date(e.date)
        })));
        return {minDate, maxDate}
    },
    getDataBetween2Dates(arr, dateMin, dateMax) {
        let result
        let ed = new Date("2018-04-21T00:00:00.000Z").getTime()
        if (dateMin && !dateMax) {
            let sd = new Date(dateMin).getTime()
            result = arr.filter(d => {
                let time = new Date(d.date).getTime();
                return (sd < time)
            })
        } else if (!dateMin && dateMax) {
            let ed = new Date(dateMax).getTime()
            result = arr.filter(d => {
                let time = new Date(d.date).getTime();
                return (time < ed)
            })
        } else if (dateMin && dateMax) {
            let sd = new Date(dateMin).getTime()
            let ed = new Date(dateMax).getTime()
            result = arr.filter(d => {
                let time = new Date(d.date).getTime()
                return (sd < time && time < ed)
            })
        }else {
            result = arr
        }
        return result
    },
    isVeryNull(val) {
        return _.isUndefined(val) || val === 0 || val === null
    }
}